import { render } from "./BuildInfoFooter.vue?vue&type=template&id=0a67dcc3&scoped=true"
import script from "./BuildInfoFooter.vue?vue&type=script&lang=js"
export * from "./BuildInfoFooter.vue?vue&type=script&lang=js"

import "./BuildInfoFooter.vue?vue&type=style&index=0&id=0a67dcc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a67dcc3"]])

export default __exports__